import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface EventType {
  id: string;
  name: string;
  code: string;
  category: string;
  requires_location: boolean;
  requires_officer: boolean;
  requires_result: boolean;
  requires_deadline: boolean;
  notify_client: boolean;
  notify_days_before?: number[];
  description?: string;
  icon?: string;
  color?: string;
  is_active: boolean;
  display_order: number;
}

export const useEventTypes = () => {
  const { data: eventTypes, isLoading } = useQuery({
    queryKey: ['event-types'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('event_types')
        .select('*')
        .eq('is_active', true)
        .order('display_order');

      if (error) throw error;
      return data as EventType[];
    },
  });

  return {
    eventTypes: eventTypes || [],
    isLoading,
  };
};
